import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface QuestionnaireAttachmentDeleteDialogProps {
  open: boolean;
  filename?: string;
  onConfirm: () => void;
  onClose: () => void;
}

export function QuestionnaireAttachmentDeleteDialog({
  open,
  filename,
  onConfirm,
  onClose,
}: QuestionnaireAttachmentDeleteDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("fileAttachments.confirmDeleteTitle")}
          </AlertDialogTitle>
          {filename && (
            <AlertDialogDescription
              className="break-words break-all min-w-0 max-w-full font-medium text-foreground"
              title={filename}
              style={{ wordBreak: "break-all", overflowWrap: "anywhere" }}
            >
              {filename}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>
            {t("common.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {t("common.delete")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
